export const pages = {
	'linkOutJP': { id: 'linkOutJP', page: 'text', getter: () => import(/* webpackChunkName: 'text' */ 'components/bolt/text/text') }
};
export const sections = [

];
